/* eslint-disable spellcheck/spell-checker */
import { MoneTracker } from 'Services/MoneTracker';
import { joinSource, getTrackSource } from 'Services/MoneTracker/utils';

import { GIFT_SOURCE_NAME, MAX_GIFTS } from '../../constants';

const POPUP_SOURCE_NAME = joinSource([GIFT_SOURCE_NAME, 'popup']);

export const trackShow = (availableSharings: number) => {
  MoneTracker.trackEvent({
    action: 'shown',
    source: joinSource([GIFT_SOURCE_NAME, 'icon']),
    type: POPUP_SOURCE_NAME,
    data: {
      available_sharings: availableSharings,
      max_sharings: MAX_GIFTS,
    },
  });
};

export const trackGenerateLink = (availableSharings: number) => {
  MoneTracker.trackEvent({
    action: 'click:generate_link',
    source: joinSource([POPUP_SOURCE_NAME, 'available']),
    type: POPUP_SOURCE_NAME,
    data: {
      available_sharings: availableSharings,
      max_sharings: MAX_GIFTS,
    },
  });
};

export const trackDoneClick = (availableSharings: number) => {
  MoneTracker.trackEvent({
    action: 'click:done',
    source: joinSource([POPUP_SOURCE_NAME, 'active']),
    type: POPUP_SOURCE_NAME,
    data: {
      available_sharings: availableSharings,
      max_sharings: MAX_GIFTS,
    },
  });
};

export const trackCopyClick = (availableSharings: number) => {
  MoneTracker.trackEvent({
    action: 'click:copy_link',
    source: joinSource([POPUP_SOURCE_NAME, 'active']),
    type: POPUP_SOURCE_NAME,
    data: {
      available_sharings: availableSharings,
      max_sharings: MAX_GIFTS,
    },
  });
};

export const trackCopyLinkClick = (availableSharings: number) => {
  MoneTracker.trackEvent({
    action: 'click',
    source: joinSource([GIFT_SOURCE_NAME, 'gift_share_modal']),
    type: joinSource([GIFT_SOURCE_NAME, 'copy_article_link_button']),
    data: {
      available_sharings: availableSharings,
      max_sharings: MAX_GIFTS,
    },
  });
};

export const trackGiftArticleLinkClick = (availableSharings: number) => {
  MoneTracker.trackEvent({
    action: 'click',
    source: joinSource([GIFT_SOURCE_NAME, 'gift_share_modal']),
    type: joinSource([GIFT_SOURCE_NAME, 'gift_full_article_button']),
    data: {
      available_sharings: availableSharings,
      max_sharings: MAX_GIFTS,
    },
  });
};

export const trackModalShown = () => {
  MoneTracker.trackEvent({
    action: 'shown',
    source: joinSource(['article', 'gift_share_icon']),
    type: 'popup',
  });
};

export const trackGenerateLinkPopupDismissed = (
  linkStatus: 'available' | 'active',
  availableGiftTotal: number,
) => {
  MoneTracker.trackEvent({
    action: 'dismiss',
    source: joinSource([GIFT_SOURCE_NAME, 'popup', linkStatus]),
    type: joinSource([GIFT_SOURCE_NAME, 'popup', 'cancel']),
    data: {
      available_sharings: availableGiftTotal,
      max_sharings: MAX_GIFTS,
    },
  });
};

export const trackGiftAndShareModalDismissed = () => {
  MoneTracker.trackEvent({
    action: 'click',
    source: joinSource([getTrackSource(), 'gift_share_icon']),
    type: joinSource(['gift_share_popup', 'cancel']),
  });
};

export const trackShareClick = (availableSharings: number) => {
  MoneTracker.trackEvent({
    action: 'click:share_link',
    source: joinSource([POPUP_SOURCE_NAME, 'active']),
    type: POPUP_SOURCE_NAME,
    data: {
      available_sharings: availableSharings,
      max_sharings: MAX_GIFTS,
    },
  });
};
